module.exports = __webpack_public_path__ + "static/top_home_bg-d41ed8f15a25295ba7a0716897812970.png";